import './App.css';
import resume from '../assets/resume.pdf';

function App() {
  return (
    <div className="page">
      <header className="site-header">
        <a href="mailto:smanikonda99@gmail.com">say hello</a>
      </header>
      <main id="home">
        <section className="intro" id="about" aria-labelledby="name">
          <h1 id="name">srikar manikonda</h1>
          <div className="bio">
            <p>currently an engineer @ <a href="https://www.methodfi.com/" target="_blank" rel="noopener noreferrer">method financial</a>.<br />previously an early software engineer @ <a href="https://onetext.com/" target="_blank" rel="noopener noreferrer">onetext</a>.</p>
          </div>
        </section>

        <ul className="interests" aria-label="Currently">
          <li>
            <a href="https://srikarmanikonda.substack.com/p/coming-soon" target="_blank" rel="noopener noreferrer">what i'm reading</a>
          </li>
          <li>
            <a href="https://open.spotify.com/playlist/2fNrBNimoysO5WYAf9gPjI" target="_blank" rel="noopener noreferrer">what i'm listening to</a>
          </li>
          <li>
            <span>what i'm thinking about</span>
            <ul>
              <li><a href="https://worksinprogress.co/issue/why-american-data-centers-cant-plug-in/" target="_blank" rel="noopener noreferrer">why american data centers can't plug in</a></li>
              <li><a href="https://worksinprogress.co/issue/liberte-egalite-radioactivite/" target="_blank" rel="noopener noreferrer">how france achieved the world's fastest nuclear buildout</a></li>
            </ul>
          </li>
        </ul>
      </main>

      <footer>
        <div className="footer-links">
          <a href={resume} target="_blank" rel="noopener noreferrer">resume</a>
          <a href="https://github.com/srikarmanikonda" target="_blank" rel="noopener noreferrer">github</a>
          <a href="https://www.linkedin.com/in/srikar-manikonda-7b5606147/" target="_blank" rel="noopener noreferrer">linkedin</a>
        </div>
      </footer>
    </div>
  );
}

export default App;
